import { Heart } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const version = "4.2.0"; // നിങ്ങളുടെ ആപ്പിന്റെ വേർഷൻ ഇവിടെ മാറ്റാം

  return (
    <footer className="w-full bg-[#F8FAFC] border-t border-slate-200/60">
      
      {/* Container with appropriate padding for Bottom Navbar */}
      <div className="max-w-4xl mx-auto px-4 pt-8 pb-24 flex flex-col items-center justify-center text-center gap-2.5"> 
        
        {/* Copyright Section (Smaller Text) */}
        <div className="text-slate-400 font-medium text-xs flex items-center gap-1.5 flex-wrap justify-center">
          &copy; {currentYear} Info Payangadi. Crafted with 
          <Heart size={12} className="text-rose-500 fill-rose-500 animate-pulse drop-shadow-sm" /> 
          in Kerala.
        </div>

        {/* Developer Credit (Stylish & Premium) */}
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] sm:text-[11px] font-bold text-slate-400 uppercase tracking-widest">
            Developed by
          </span>
          <a 
            href="https://varunchengal.in" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-xs sm:text-[13px] font-black bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500 hover:opacity-80 transition-opacity"
          >
            Varun Chengal
          </a>
        </div>

        {/* Version Badge (Sleek & Minimal) */}
        <div className="mt-1.5 bg-white/60 backdrop-blur-sm px-3 py-1 rounded-lg text-[9px] font-black text-slate-300 tracking-[0.2em] border border-slate-100 shadow-sm uppercase">
          Version {version}
        </div>

      </div>
    </footer>
  );
}